<template>
  <router-link :to="to" class="inline-flex items-center px-1 pt-2 text-sm font-medium leading-5 text-gray-600 transition duration-150 ease-in-out focus:outline-none focus:text-gray-900 hover:text-gray-700 hover:border-gray-300" :class="this.$route.path === to ? 'text-gray-900 border-b-4 border-yellow-500' : 'border-b-4 border-transparent'">
    {{ title }}
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  }
}
</script>
